export default __webpack_public_path__ + "static/media/about1.c2d58fd9.png";